import FormFieldIndex from './FormFieldIndex';
import FormFieldCreate from './FormFieldCreate';
import FormFieldSettings from './FormFieldSettings';
import FormFieldSingle from './FormFieldSingle';

export default function (app) {

    const settings = FormFieldSettings;

    app.addModel({
        name: settings.key,
        path: settings.path,
        modelName: settings.modelName,
        endpoint: settings.endpoint,
        idKey: settings.idKey,
        primaryKey: settings.primaryKey,
    });

    // app.addMenu({
    //     key: settings.key,
    //     zone: settings.zone,
    //     label: settings.title,
    //     priority: 14,
    //     items: [
    //         {
    //             label: "All",
    //             path: settings.path,
    //             caps: settings.indexCaps
    //         },
    //         {
    //             label: "Add New",
    //             path: settings.path + "/create",
    //             caps: settings.createCaps
    //         }
    //     ],
    // });

    FormFieldIndex(app, settings);

    FormFieldCreate(app, settings);

    FormFieldSingle(app, settings);

}